module.exports = new __parcel__URL__("debuggerWorker.212ead39.js").toString();